<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  html, body, div, p, h1, h2, h3, h4, h5, ol, ul, li, dl, dt, dd, form, input, textarea, select, span, table, tr, td, img {
    margin: 0;
    padding: 0;
    border: 0;
  }
  html, body {
    background: white;
    color: rgba(122,122,122,1);
    font-family: "HYQiHei-EES", "Hiragino Sans GB", "Noto Sans", "MicrosoftYahei", "Helvetica Neue", "Arial";
    user-select: element;
    -webkit-user-select: element;
    -webkit-touch-callout:none;
    -webkit-font-smoothing: antialiased;
    font-size: 0.32rem;
    color: rgba(122,122,122,1);
    height: 100%;
  }
  *:focus, *:hover {
    outline: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }
  :not(input,textarea) {
    -webkit-touch-callout: none;
    -webkit-user-select: element;
    user-select: element;
  }
  input, textarea {
    box-shadow:0px 0px 0px rgba(0,0,0,0);
    -webkit-appearance: none;
  }
  input, textarea {
    outline: none;
    border: none;
    border-radius: 0;
  }
  input::-moz-focus-inner,input::-webkit-focus-inner,input::focus-inner {
    border: 0;
  }
  textarea {
    resize: none;
  }
  ul, ol, li {
    list-style: none;
  }
  a {
    text-decoration: none;
    color: #333;
    outline: none;
  }
  a,input{
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }
  a:focus, input:focus {
    outline: 0;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }
  .lx-toast {
    height: 0.96rem;
    line-height: 0.96rem;
    padding: 0 0.48rem;
    font-size: 0.32rem;
    background: rgba(0, 0, 0, 0.7);
    font-family:HYQiHei-GZS;
    background:rgba(77,77,77,1);
    box-shadow: 0px 10px 30px 0px rgba(111,114,117,0.4);
    border-radius: 8px ;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    overflow-y: scroll;
  }
</style>

<!--dialog css 覆盖-->
<style lang="stylus" rel="stylesheet/stylus">
  body .dg-backdrop
    background-color rgba(0,0,0,.4)
  body
    .dg-content-cont
      top 28%
      width 5.4rem
      left: 50%;
      transform: translateX(-50%);
    .dg-main-content
      padding 0.6rem 0 0 0
    .dg-content-body
      padding-bottom 0.5rem
      border-bottom 1px solid rgba(224,224,224,1)
    .dg-content
      text-align center
      /*height 0.48rem;*/
      font-size 0.34rem
      color #333333
      line-height 0.48rem
      padding 0 0.32rem
    .dg-content-footer
      padding 0
    .dg-btn
      height 1.14rem
      width 50%
      background none
      border none
      border-radius 0
      font-size 0.3rem
    .dg-btn--cancel
      box-shadow 1px 0px 1px #e0e0e0;
      color #00BBDC
    .dg-btn--ok
      color #999999
</style>



// WEBPACK FOOTER //
// src/App.vue